export const useCases = [
    {
        caption: "Healthcare Apps",
        message: "AI-powered diagnosis, symptom tracking, and personalized treatment plans"
    },
    {
        caption: "E-Commerce",
        message: "Smart product recommendations and visual search capabilities"
    },
    {
        caption: "Logistics",
        message: "Smart hotel/lodge booking, real-time bus seat booking applications."
    },
    {
        caption: "Education",
        message: "Personalized learning paths and intelligent tutoring systems"
    },
    {
        caption: "Fitness",
        message: "AI-powered personal trainers and real-time form correction"
    },
    {
        caption: "Entertainment",
        message: "Content curation and immersive AR/VR experiences"
    }
]

export const secUseCases = [
    {
        caption: "Ransomware Defense",
        message: "AI-powered detection and prevention of ransomware attacks",
        stat: "99.9% Detection Rate"
    },
    {
        caption: "Phishing Protection",
        message: "Machine learning models that identify sophisticated phishing attempts",
        stat: "95% Accuracy"
    },
    {
        caption: "Zero-Day Threats",
        message: "Predictive AI that identifies unknown threats before they strike",
        stat: "Real-time Protection"
    },
    {
        caption: "Insider Threats",
        message: "Behavioral analysis to detect malicious insider activities",
        stat: "24/7 Monitoring"
    },
    {
        caption: "DDos Mitigation",
        message: "AI-driven traffic analysis and automatic attack mitigation",
        stat: "Instant Response"
    },
    {
        caption: "Data Breach Prevention",
        message: "Intelligent data loss prevention with AI classification",
        stat: "100% Compliance"
    }
]